import "./index.css";
import { Link } from "react-router-dom";

export const Reportes = () => {
  return (
    <div className="container">
      <div className="indicator">
        <h1>Reportes</h1>
        <ul>
          <li>
            <Link to={`../stock-preimpresos`}>Consulta stock preimpresos</Link>
          </li>
          <li>
            <Link to={`../stock-instantaneos`}>
              Consulta stock instantaneos
            </Link>
          </li>
          <li>
            <Link to={`../premios-pagados-instantaneos`}>
              Consulta premios pagados instantaneos
            </Link>
          </li>
          <li>
            <Link to={`../comprobantes-preimpresos`}>
              Consulta comprobantes preimpresos
            </Link>
          </li>
          <li>
            <Link to={`../premios-pagados-preimpresos`}>
              Consulta premios pagados preimpresos{" "}
            </Link>
          </li>
          <li>
            <Link to={`../comprobantes-instantaneos`}>
              Consulta comprobantes instantaneos
            </Link>
          </li>
          <li>
            <Link to={`../entregas-devoluciones-instantaneos`}>
              Matriz de control Entregas-Devoluciones Instantaneos
            </Link>
          </li>
          <li>
            <Link to={`../entregas-devoluciones-preimpresos`}>
              Matriz de control Entregas-Devoluciones Instantaneos
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};
